export class Display {
    private line1El: HTMLElement;
    private line2El: HTMLElement;

    constructor() {
        this.line1El = document.getElementById("line1")!;
        this.line2El = document.getElementById("line2")!;
    }

    line1(text: string): void {
        text = text.replaceAll(" ", "&nbsp;");
        text = text.replaceAll("•", "&bull;");
        this.line1El.innerHTML = text;
    }

    line2(text: string): void {
        text = text.replaceAll(" ", "&nbsp;");
        text = text.replaceAll("•", "&bull;");
        this.line2El.innerHTML = text;
    }
}

export default new Display();
